import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults, validateParameters } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\ElectronicSignatureDownloadYousignDocumentController::__invoke
* @see app/Http/Controllers/ElectronicSignature/ElectronicSignatureDownloadYousignDocumentController.php
* @route '/api/electronic-signature/download-yousign-document/{electronicSignature}/{document_id?}'
*/
const ElectronicSignatureDownloadYousignDocumentController = (args: { electronicSignature: string | number | { id: string | number }, document_id?: string | number } | [electronicSignature: string | number | { id: string | number }, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElectronicSignatureDownloadYousignDocumentController.url(args, options),
    method: 'get',
})

ElectronicSignatureDownloadYousignDocumentController.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/download-yousign-document/{electronicSignature}/{document_id?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\ElectronicSignatureDownloadYousignDocumentController::__invoke
* @see app/Http/Controllers/ElectronicSignature/ElectronicSignatureDownloadYousignDocumentController.php
* @route '/api/electronic-signature/download-yousign-document/{electronicSignature}/{document_id?}'
*/
ElectronicSignatureDownloadYousignDocumentController.url = (args: { electronicSignature: string | number | { id: string | number }, document_id?: string | number } | [electronicSignature: string | number | { id: string | number }, document_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
            document_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "document_id",
    ])

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
        document_id: args.document_id,
    }

    return ElectronicSignatureDownloadYousignDocumentController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace('{document_id?}', parsedArgs.document_id?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\ElectronicSignatureDownloadYousignDocumentController::__invoke
* @see app/Http/Controllers/ElectronicSignature/ElectronicSignatureDownloadYousignDocumentController.php
* @route '/api/electronic-signature/download-yousign-document/{electronicSignature}/{document_id?}'
*/
ElectronicSignatureDownloadYousignDocumentController.get = (args: { electronicSignature: string | number | { id: string | number }, document_id?: string | number } | [electronicSignature: string | number | { id: string | number }, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElectronicSignatureDownloadYousignDocumentController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\ElectronicSignatureDownloadYousignDocumentController::__invoke
* @see app/Http/Controllers/ElectronicSignature/ElectronicSignatureDownloadYousignDocumentController.php
* @route '/api/electronic-signature/download-yousign-document/{electronicSignature}/{document_id?}'
*/
ElectronicSignatureDownloadYousignDocumentController.head = (args: { electronicSignature: string | number | { id: string | number }, document_id?: string | number } | [electronicSignature: string | number | { id: string | number }, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElectronicSignatureDownloadYousignDocumentController.url(args, options),
    method: 'head',
})

export default ElectronicSignatureDownloadYousignDocumentController